import React, { useEffect } from "react";
import UserP2PTable from "./UserP2POrdersTable";
import { Card } from "../../../../Units/Card.styled";
import { TabHeader, TableTab2 } from "../../../../Units/TabsAndLinkStyled";
import { withTheme } from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import caret_down from "../../../../../assets/images/caret-down1.svg";
import { Select } from "../../../../../UI toolkit/Dropdown/Dropdown";
import Statbox from "./Statbox";
import {
  getUserP2PAds,
  getUserP2POrders,
  getUserP2PWalletStats,
  updateUserP2PActiveTab,
} from "../../../../../store/Actions/P2PActions";
import UserP2PAdsTable from "./UserP2PAdsTable";
import UserP2POrdersTable from "./UserP2POrdersTable";

const UserP2P = ({
  theme,
  updateStatus,
  activeTab,
  activeStatus,
  totalPages,
  page,
  activeOrderStatus,
  activeAdsStatus,
  updateActiveTab,
  getUserP2PWalletStats,
  userP2PWalletStats,
  match,
  getOrders,
  getAds,
  user,
}) => {
  const tabs = [
    { text: "Ads", value: "ads" },
    { text: "Orders", value: "orders" },
  ];

  // const currentStatus = activeStatus[activeTab];

  const handleTabChange = (tab) => {
    console.log("tab", tab);

    updateActiveTab(tab);
    // updateStatus({
    //   tab: activeTab,
    //   value: status,
    // });
  };

  // const nextButtonDisabled = () => {
  //   return !(currentPage < totalPage - 1);
  // };

  // const handlePrevPage = () => {
  //   if (currentPage > 0) {
  //     updatePage({
  //       tab: activeTab,
  //       status: currentStatus,
  //       value: currentPage - 1,
  //     });
  //   }
  // };

  useEffect(() => {
    getUserP2PWalletStats(match.params.id);
    // getAds(match.params.id);
  }, []);

  return (
    <div className="">
      {/* <pre>
{JSON.stringify(
{
  updateStatus,
  activeTab,
  activeStatus,
  totalPages,
  page,
  activeOrderStatus,
  activeAdsStatus,
},
null,
2
)}
</pre> */}
      <div
        className="flex w-full"
        style={{
          height: "16rem",
        }}
      >
        <div
          className="flex flex-col justify-between mr-5"
          style={{
            width: "65%",
            height: "100%",
          }}
        >
          <Card className="mt-4 h-full">
            <div className="flex pl-6">
              {/* <pre>{JSON.stringify(userP2PWalletStats, null, 2)}</pre> */}
              <Statbox
                name="P2P USDT Ad Amount"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalUSDTAdAmount
                    : null
                }
                isMoney={true}
              />
              <Statbox
                name="P2P USDT Ad Consumed"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalUSDTAdConsumed
                    : null
                }
                isMoney={true}
              />
              <Statbox
                name="P2P USDT Ad Remaining"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalUSDTAdRemaining
                    : null
                }
                isMoney={true}
              />
            </div>
          </Card>
          <Card className="mt-4 h-full">
            <div className="flex pl-6">
              {/* <pre>{JSON.stringify(userP2PWalletStats, null, 2)}</pre> */}
              <Statbox
                name="P2P NGN Ad Amount"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalNGNAdAmount
                    : null
                }
                isMoney={true}
              />
              <Statbox
                name="P2P NGN Ad Consumed"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalNGNAdConsumed
                    : null
                }
                isMoney={true}
              />
              <Statbox
                name="P2P NGN Ad Remaining"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalNGNAdRemaining
                    : null
                }
                isMoney={true}
              />
            </div>
          </Card>
        </div>
        <div className="flex flex-col justify-between">
          <Card className="mt-4 h-full">
            <div className="flex pl-6">
              {/* <pre>{JSON.stringify(userP2PWalletStats, null, 2)}</pre> */}
              <Statbox
                name="Total Completed Ads"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalCompletedAds
                    : null
                }
                isMoney={true}
              />
              <Statbox
                name="Total Completed Orders"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalCompletedOrders
                    : null
                }
                isMoney={true}
              />
            </div>
          </Card>
          <Card className="mt-4 h-full">
            <div className="flex pl-6">
              {/* <pre>{JSON.stringify(userP2PWalletStats, null, 2)}</pre> */}
              <Statbox
                name="Total Trading Volume"
                value={
                  userP2PWalletStats
                    ? userP2PWalletStats.totalTradingVolume
                    : null
                }
                isMoney={true}
              />
            </div>
          </Card>
        </div>
      </div>

      <Card className="mt-4">
        <TabHeader>
          <div className="lg:flex justify-between">
            <div className="lg:w-8/12">
              <TableTab2
                margin
                tabs={tabs}
                activeTab={activeTab}
                handleDispatch={handleTabChange}
                callback={(active) => {
                  console.log(active);
                }}
              />
            </div>
            <div className="lg:w-4/12 flex justify-end my-3 mx-3 lg:my-1.5 lg:mx-1.5 py-5 lg:py-0">
              <div className="w-6/12">
                <Select
                  bgImg={caret_down}
                  // bgColor={"#112E46"}
                  // color={"#fff"}
                  bgColor={theme.colors.bg}
                  color={theme.colors.color}
                  border={"1px solid #fff"}
                  borderRadius={"4px"}
                  p={"5px 15px"}
                  data={tabs}
                  defaultValue={"-- Status --"}
                  properyToShow={"text"}
                  hoverBg={"#FFF"}
                  hoverColor={"#112E46"}
                  fontSize={"16px"}
                  callback={(option, idx, arr) => {
                    handleTabChange(option.value);
                  }}
                />
              </div>
            </div>
          </div>
        </TabHeader>
      </Card>
      <div className="mt-4">
        {activeTab === "ads" ? (
          <UserP2PAdsTable
            userId={match.params.id}
            user={{
              email: user?.profile?.email,
              firstName: user?.profile?.first_name,
              lastName: user?.profile?.last_name,
            }}
          />
        ) : activeTab === "orders" ? (
          <UserP2POrdersTable
            userId={match.params.id}
            user={{
              email: user?.profile?.email,
              firstName: user?.profile?.first_name,
              lastName: user?.profile?.last_name,
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.p2p.loading,
    error: state.p2p.error,
    orders: state.p2p.orders,
    ads: state.p2p.ads,
    activeOrderStatus: state.p2p.userP2POrdersActiveStatus,
    activeAdsStatus: state.p2p.userP2PAdsActiveStatus,
    userP2PWalletStats: state.p2p.userP2PWalletStats,
    page: state.p2p.userP2PPage,
    activeTab: state.p2p.userP2PActiveTab,
    totalPages: state.p2p.userP2PTotalPages,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveTab: (tab) => dispatch(updateUserP2PActiveTab(tab)),
    getUserP2PWalletStats: (id) => dispatch(getUserP2PWalletStats(id)),
    getOrders: (query) => dispatch(getUserP2POrders(query)),
    getAds: (id) => dispatch(getUserP2PAds(id)),
    // getSavings: (query) => dispatch(getSavings(query)),
    // updateStatus: (status) => dispatch(updateSavingsActiveStatus(status)),
    // updatePage: (page) => dispatch(updateSavingsPage(page)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(UserP2P)));
